/**
 * Charge `/api/portfolio/tasks` ou `/api/portfolio/insights` (plan §1) selon `need`.
 * Les clés absentes/vides ne sont jamais envoyées : `assigneeId` par exemple est omis quand
 * aucun membre n'est filtré, plutôt que d'écrire `assigneeId=`.
 */

import { api } from '../lib/api.js';
import { useAsync } from './useAsync.js';

export function useOverview({ from, to, teamId, projectId, assigneeId, need }) {
  const { data, loading, error, reload } = useAsync(
    (signal) => {
      const params = new URLSearchParams();
      params.set('from', from);
      params.set('to', to);
      if (teamId) params.set('teamId', teamId);
      if (projectId) params.set('projectId', projectId);
      if (need === 'tasks' && assigneeId) params.set('assigneeId', assigneeId);
      const path = need === 'insights' ? '/portfolio/insights' : '/portfolio/tasks';
      return api.get(`${path}?${params.toString()}`, { signal }).then((r) => r.data);
    },
    [from, to, teamId, projectId, assigneeId, need],
  );

  return { data, loading, error, reload };
}
